import { createContext } from 'react';

import { TAiReviewDto, TAiSimulationSummaryDto, TPrototypeDto } from '@app-velocity/av-api-v2';

export type AiChatContextType = {
  scenario: TPrototypeDto;
  review: TAiReviewDto;
  latestSimulationWithSelectedPersona: TAiSimulationSummaryDto | null;
  navigateToElement?: (elementId: string) => void;
  persona?: string
};

export const AiChatContext = createContext<AiChatContextType>({
  scenario: {} as TPrototypeDto,
  review: {} as TAiReviewDto,
  latestSimulationWithSelectedPersona: null,
  persona: 'default'
});
